module.exports = __webpack_public_path__ + "img/pixeldebates_logo.65c3b587.png";